// extracted by mini-css-extract-plugin
module.exports = {"editor":"Editor_editor__2xSfa","editorSection":"Editor_editorSection__3pzbJ"};